@file:OptIn(org.jetbrains.compose.resources.InternalResourceApi::class)

package limasoul.client.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.FontResource
import org.jetbrains.compose.resources.InternalResourceApi

private object CommonMainFont0 {
  public val circe_bold: FontResource by 
      lazy { init_circe_bold() }

  public val circe_extra_bold: FontResource by 
      lazy { init_circe_extra_bold() }

  public val circe_extra_light: FontResource by 
      lazy { init_circe_extra_light() }

  public val circe_light: FontResource by 
      lazy { init_circe_light() }

  public val circe_regular: FontResource by 
      lazy { init_circe_regular() }
}

@InternalResourceApi
internal fun _collectCommonMainFont0Resources(map: MutableMap<String, FontResource>) {
  map.put("circe_bold", CommonMainFont0.circe_bold)
  map.put("circe_extra_bold", CommonMainFont0.circe_extra_bold)
  map.put("circe_extra_light", CommonMainFont0.circe_extra_light)
  map.put("circe_light", CommonMainFont0.circe_light)
  map.put("circe_regular", CommonMainFont0.circe_regular)
}

internal val Res.font.circe_bold: FontResource
  get() = CommonMainFont0.circe_bold

private fun init_circe_bold(): FontResource = org.jetbrains.compose.resources.FontResource(
  "font:circe_bold",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/font/circe_bold.otf", -1, -1),
    )
)

internal val Res.font.circe_extra_bold: FontResource
  get() = CommonMainFont0.circe_extra_bold

private fun init_circe_extra_bold(): FontResource = org.jetbrains.compose.resources.FontResource(
  "font:circe_extra_bold",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/font/circe_extra_bold.otf", -1, -1),
    )
)

internal val Res.font.circe_extra_light: FontResource
  get() = CommonMainFont0.circe_extra_light

private fun init_circe_extra_light(): FontResource = org.jetbrains.compose.resources.FontResource(
  "font:circe_extra_light",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/font/circe_extra_light.otf", -1, -1),
    )
)

internal val Res.font.circe_light: FontResource
  get() = CommonMainFont0.circe_light

private fun init_circe_light(): FontResource = org.jetbrains.compose.resources.FontResource(
  "font:circe_light",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/font/circe_light.otf", -1, -1),
    )
)

internal val Res.font.circe_regular: FontResource
  get() = CommonMainFont0.circe_regular

private fun init_circe_regular(): FontResource = org.jetbrains.compose.resources.FontResource(
  "font:circe_regular",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/font/circe_regular.otf", -1, -1),
    )
)
